export default __webpack_public_path__ + "static/media/superBonus.c3e8a12e.png";